// this has to come before React/ReactDOM imports
import { useRecoilState } from 'recoil';

// Your top level component
import App from './App';
import { userState } from './helpers/userState';

const RecoilCompat = () => {
  const [user, setUser] = useRecoilState(userState);
  return (
    <App
      user={user}
      setUser={(u) => {
        Console.log('Deprecated setUser from App prop - use Recoil instead');
        return setUser(u);
      }}
    />
  );
};

export default RecoilCompat;
